function vzScrollToCommentInit() {
  jQuery('#comment-count').on('click', function() { // Klick auf den Button
    jQuery('body,html').animate({
      scrollTop: jQuery('#comments').offset().top -125}, 800);
    return false;
  });
}
